module.exports = __webpack_public_path__ + "img/CR_sinoRussianRailwaybanner.1235fc0e.jpg";